<template>
        <v-card class="text-right">
            <v-card-title>
                {{ isCreate ? "إضافة التصنيف" : "تفاصيل التصنيف"}}
                <div class="mr-auto d-flex">
                    <small class="pl-2">
                        <label for="isHidden">إخفاء</label>
                    </small>
                    <v-switch
                        id="isHidden"
                        class="m-0"
                        color="IMThemeOrange"
                        v-model="modelCategory.isHidden"
                        light
                    >
                    </v-switch>
                </div>
            </v-card-title>
            <v-card-text class="p-0" style="height: calc(100vh - 140px)">
                <v-col cols="12">
                    <v-form
                        ref="form"
                        v-model="valid"
                    >
                        <label for="cat-logo">شعار التصنيف</label>
                        <div class="logo-container text-center">
                            <img :src="
                                !this.modelCategory.logo[0] ? placeholder :
                                (!!this.modelCategory.logo[0].path ?
                                (domainHost + this.modelCategory.logo[0].path.replace('~', '')) :
                                this.modelCategory.logo[0].base64)"
                                alt="category logo" width="36"
                            />
                        </div>
                        <div class="d-flex">
                            <dragDropImage @uploaded="uploadImageLogo" id="logo" title="أضف صورة" class="overflow-hidden" style="height: 38px; justify-content: flex-end; padding: 7px;"/>
                            <v-btn class="rounded-xl mt-4 mr-2" color="info" @click="fireGalleryDialog('معرض الشعارات', true, 1)">
                                <v-icon>mdi-grid</v-icon>
                            </v-btn>
                        </div>
                        <label for="cat-name">اسم التصنيف</label>
                        <v-text-field
                            id="cat-name"
                            solo
                            :rules="categoryNameRules"
                            v-model="modelCategory.name"
                        ></v-text-field>
                        <label for="cat-image">صورة التصنيف</label>
                        <div class="image-container text-center">
                            <img :src="
                                !this.modelCategory.image[0] ? placeholder :
                                (!!this.modelCategory.image[0].path ?
                                (domainHost + this.modelCategory.image[0].path.replace('~', '')) :
                                this.modelCategory.image[0].base64)"
                                alt="category logo" class="" style="width: 320px; max-height: 400px;"
                            />
                        </div>
                        <div class="d-flex">
                            <dragDropImage @uploaded="uploadImageCategory" id="image" title="أضف صورة" class="overflow-hidden" style="height: 38px; justify-content: flex-end; padding: 7px;"/>
                            <v-btn class="rounded-xl mt-4 mr-2" color="info" @click="fireGalleryDialog('معرض الصور', true, 0)">
                                <v-icon>mdi-grid</v-icon>
                            </v-btn>
                        </div>
                    </v-form>
                </v-col>
            </v-card-text>
            <v-card-actions>
                <v-btn outlined dense color="secondary" type="button" @click.prevent="close">إلغاء</v-btn>
                <v-btn dense color="success" type="button" @click.prevent="ActionCategory(modelCategory); close();" :disabled="!valid">تم</v-btn>
                <v-btn dense color="error" type="button" @click.prevent="DeleteCategory(modelCategory); close();" v-if="!isCreate">حذف</v-btn>
            </v-card-actions>
            <v-dialog
                v-model="galleryDialog"
                scrollable
            >
                <imageGallery :type="type" @selectImage="selectImageFomGallery" @close="fireGalleryDialog('', false)" :title="imageGalleryTitle"/>
            </v-dialog>
        </v-card>
</template>
<script>
import imageGallery from "./image-gallery"
import { singleImageCompressor } from "@/plugins/fileCompresser.service.js";
import dragDropImage from "@/components/drag-drop-images";
import { mapGetters, mapActions } from "vuex";
export default {
    name: "action-category",
    components: {
        dragDropImage,
        imageGallery
    },
    data:() => ({
        galleryDialog: false,
        valid: false,
        type: 0,
        categoryNameRules: [
            v => !!v || 'يرجى اختيار اسم للتصنيف',
            v => (v && v.length >= 3) || 'اسم التصنيف يجب ان يكون اطول من 3 محارف',
        ],
        imageGalleryTitle: ''
    }),
    props: {
        isCreate: Boolean
    },
    computed: {
        ...mapGetters(["modelCategory", "placeholder", "domainHost", "imagesGallery"]),
    },
    methods: {
        ...mapActions(["ActionCategory", "DeleteCategory", "getGalleryImages"]),
        close(){
            this.$emit('close');
        },
        uploadImageLogo(file){
            singleImageCompressor(file, this.modelCategory.logo);
        },
        uploadImageCategory(file){
            singleImageCompressor(file, this.modelCategory.image);
        },
        fireGalleryDialog(title, is, type) {
            this.galleryDialog = is
            this.imageGalleryTitle = title
            if(type != undefined) {
                this.getGalleryImages(type)
            }
            this.type = type
        },
        selectImageFomGallery(path, type) {
            if(type) {
                this.modelCategory.logo.pop();
                this.modelCategory.logo.push({
                    id: 0,
                    base64: null,
                    path: path
                })
            } else {
                this.modelCategory.image.pop();
                this.modelCategory.image.push({
                    id: 0,
                    base64: null,
                    path: path
                })
            }
        }
    }
}
</script>